import { combineReducers } from 'redux';
import nodesReducer from './nodes';
import userReducer from './user';

const rootReducer = combineReducers({
  nodesReducer,
  userReducer
});

export default rootReducer;